import {css} from 'styled-components';

export const firebaseUiStyles = css`

`